var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudgetImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.339,
    height: 39.718,
    viewBox: "0 0 622 741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 622,
    height: 741,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAoCAYAAABw65OnAAACXUlEQVRYhe3YTYhOURzH8c9olNHEClmMGu9EyVsYyUtk8lJCUSjKS1lYKcpOXsvCAkVhsBCarJSyUGRDyQKNl0mTl0lisvKSl26dR9f1THPvfea5LPzqds+555z/+d5z/ud/zr01fWecbcNof09ttQHgFq6hT4Eo37EQ82vDgzPhKlrtEUTpzYfk7HwwpqBfzvZD9cLwH8M9rKvESKUQw8N9eSXOnRdiA+5icsgvi7wcT7G2CIidaMHUMmUjMSmrwdoUdeJqwOFY/iJaUYOJmInT1YaYG0t/Swz9paydl5R1Oj4l2p7EoLyd54W4ga8hHU3B5hBwoimYXRTEByxKjEg9NobQ31IERKSbGIPj6EqURUv3chEQkTqwHY3h/i5Wtgpji4AoqSuMyPTE83HVhlhR5k0bEvmXWQxmjRONIThFuoNXwTGbY3Ueh02tahDTYulZZcrfYCl+ZDGaJ05swVU8iXX2ArvDNLVntJkZ4j1OBb+IlumD8PwCDuJjVoA8EEndDxH0dSVGKoXYhmE4kaHNASzoTYgv6ExZN4K9jV1Jxy3qiL8+LN2mkP/Nd7JADMzReR3O4xz6d9dvTxAjsBXXw35xBeNTAszDozQn8WSwis4IE0IEbE6cpCKtDNdR7MfbbuzuxZ6UsH9AzAlbdU/aEc4Q+3AkHPUijQpfck0pbPxScjoGZGgb1T0UImcUvNYknC+1kiPxOauB8AHUmqJetyryK/w/RI/6JyHqC+q3Lp5Jro62gv7YdJSDKEW+h9hUAERJnXGI1bF09EOr2iq5wZISxHMsDlfx4tlP/zNknqp+TMgAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetImpact);
export default __webpack_public_path__ + "static/media/budget-impact.75206de8.svg";
export { ForwardRef as ReactComponent };